module.exports = __webpack_public_path__ + "img/dot-yellow.cfb6d151.svg";